@let errors = control().errors;

@if (errors?.['required']) {
<ng-container>
    {{ messages()?.required ?? 'shared.validation.required' | translate }}
</ng-container>
} @else if (errors?.['email']) {
<ng-container>
    {{ messages()?.email ?? 'shared.validation.invalidEmail' | translate }}
</ng-container>
} @else if (errors?.['min']) {
<ng-container>
    {{ messages()?.min ?? 'shared.validation.minDigitsLength' | translate }}
</ng-container>
} @else if (errors?.['minlength']) {
<ng-container>
    {{
    messages()?.minlength ?? 'shared.validation.minDigitsLength' | translate
    }}
</ng-container>
} @else if (errors?.['max']) {
<ng-container>
    {{ messages()?.max ?? 'shared.validation.maxDigitsLength' | translate }}
</ng-container>
} @else if (errors?.['maxlength']) {
<ng-container>
    {{
    messages()?.maxlength ?? 'shared.validation.maxDigitsLength' | translate
    }}
</ng-container>
} @else if (errors?.['notOnlySpaces']) {
<ng-container>
    {{
    messages()?.notOnlySpaces ?? 'shared.validation.notOnlySpaces' | translate
    }}
</ng-container>
} @else if (errors?.['arabicPattern']) {
<ng-container>
    {{
    messages()?.arabicPattern ?? 'shared.validation.arabicPattern' | translate
    }}
</ng-container>
} @else if (errors?.['englishPattern']) {
<ng-container>
    {{
    messages()?.englishPattern ?? 'shared.validation.englishPattern'
    | translate
    }}
</ng-container>
} @else if (errors?.['textContainsNumbers']) {
<ng-container>
    {{
    messages()?.textContainsNumbers ??
    'shared.validation.onlyTextWithoutNumbers' | translate
    }}
</ng-container>
} @else if (errors?.['digits']) {
<ng-container>
    {{
    messages()?.digits ?? 'shared.validation.digits' | translate
    }}
</ng-container>
} @else if (errors?.['username']) {
<ng-container>
    {{
    messages()?.digits ?? 'shared.validation.username' | translate
    }}
</ng-container>
}
@else if (errors?.['passwordComplexity']) {
<ng-container>
    {{
    messages()?.passwordComplexity ??
    'shared.validation.passwordComplexity' | translate
    }}
</ng-container>
}